import styled from 'styled-components';

export const TimeZone = styled.p`
  font-style: italic;
  margin-bottom: 1em;
`;
